import React from 'react';
import { buildSiteFontsCss } from '../utils/defaults';

export default function SiteFontStyles({ typography }) {
  const css = buildSiteFontsCss(typography);
  if (!css) return null;
  return <style>{css}</style>;
}
